import React from 'react';
import { Badge } from '@/components/ui/badge';
import { PR_STATUS } from '@/services/prApi';

export const PrBadge = ({ status, testId }) => {
  const [label, cls] = PR_STATUS[status] || [status, ''];
  return <Badge variant="outline" className={`${cls} whitespace-nowrap`} data-testid={testId}>{label}</Badge>;
};

export default PrBadge;
